/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Ndafile_Pdforword4Inputs */

const en_coinvestments_ndafile_pdforword4 = /** @type {(inputs: Coinvestments_Ndafile_Pdforword4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NDA (PDF or Word)`)
};

/**
* | output |
* | --- |
* | "NDA (PDF or Word)" |
*
* @param {Coinvestments_Ndafile_Pdforword4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_ndafile_pdforword4 = /** @type {((inputs?: Coinvestments_Ndafile_Pdforword4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Ndafile_Pdforword4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_ndafile_pdforword4(inputs)
});
export { coinvestments_ndafile_pdforword4 as "coInvestments_ndaFile_pdfOrWord" }